import { Button, Responsive } from '@cian/ui-kit';
import { IconActionReload16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

export interface IShowMoreButtonProps {
  onClick?(): void;
}

export const ShowMoreButton: React.FC<IShowMoreButtonProps> = ({ onClick }) => {
  return (
    <>
      <Responsive desktop>
        <Button
          size="XS"
          theme="stroke_primary"
          beforeIcon={<IconActionReload16 color="icon-main-default" />}
          data-name="ShowMoreButton"
          onClick={onClick}
        >
          Показать ещё
        </Button>
      </Responsive>
      <Responsive phone tablet>
        <Button
          fullWidth
          theme="fill_secondary"
          beforeIcon={<IconActionReload16 color="icon-main-default" />}
          data-name="ShowMoreButton"
          onClick={onClick}
        >
          Показать ещё
        </Button>
      </Responsive>
    </>
  );
};
